module.exports = __webpack_public_path__ + "img/santa-hover.5ca35232.png";